<template>
  <div class="welfare-content">
    
    <van-sticky>
      <div>
        <StatusView />
        <div class="navbox">
            <img class="left" src="@/assets/nav/yz_nav_fh.png" alt="" v-on:click="goBack()"/>
            <div class="title">福利宝库</div>
            <div v-on:click="goReocrd()" class="right">兑换记录</div>
        </div>
      </div>
    </van-sticky>
    

    <div v-on:click="goSearch()" class="search">
      搜索游戏
    </div>

    <!-- <van-search
     v-model="state.gamename" 
     placeholder="搜索游戏"
     background="transparent"
     left-icon="null" 
     input-align="center"/> -->

     <div>
      <div class="swiperLottery">
        <div class="swiper-wrapper" ref="slides">
          <div class="swiper-slide" v-for="(item, index) in state.images" :key="index">
            <img :src="item.pic1" alt="" />
          </div>
        </div>
      </div>

      <div class="game-info" v-show="state.activeGame.gamename">
        <span class="gamename">{{ state.activeGame.gamename }}</span>
        <div class="center">
          <div class="discount" v-if="state.activeGame.firstpay > 0 && state.activeGame.firstpay < 1">
            {{ state.activeGame.firstpay }}折
          </div>
          <div class="tag">
            {{ state.activeGame.typeword }}
          </div>
        </div>
        <div class="gift">
          有<span>{{ state.activeGame.countGift }}</span>个礼包待兑换
        </div>
      </div>


     </div>


     <div class="gift-box">

          <div class="coupon-list">
            <van-list
              v-model:loading="state.loading"
              :finished="state.finished"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="onLoad"
            >
              <van-grid :gutter="24" :column-num="3" :border="false" :center="false">
                <van-grid-item
                  v-for="(item, i) in state.gameList"
                  :key="i + '-list'"
                >
                  <template #default>
                    <div class="coupon-item">
                      <img class="coupon-img" :src="item.prop_icon" alt="" />
                      <div class="coupon-name van-ellipsis">{{item.prop_name}}</div>
                      <div class="coupon-num">
                        <img src="@/assets/game/ic_welfare_coin.webp" alt="" />
                        <span>{{ item.need_gold }}</span>
                      </div>
                      <div v-on:click="goExchange(item)" :class="item.is_exchanged == 0 ? `coupon-btn` : `coupon-btn2`">{{ item.is_exchanged == 0 ? `兑换` : `已兑换` }}</div>

                      <div v-if="item.user_limit > 0" class="coupon-limit">限{{item.user_limit}}件</div>
                    </div>
                  </template>
                </van-grid-item>
              </van-grid>
            </van-list>
          </div>
     </div>



     <welfareTreasureGamePopup v-model:show-game="state.showGame" @gameClick="onGameItem" />



     <van-popup v-model:show="state.show">
      <div class="popup-box">
        <div class="titlebox">
          <h3>兑换成功</h3>
          <img @click="state.show = false" class="closeimg" src="@/assets/game/game_sign_close.png" alt="">
        </div>

        <div class="imgbox">
          <img :src="state.successData.prop_icon" alt="">
        </div>
        
        <div class="name">{{ state.successData.prop_name }}</div>
        <div class="tip">进入游戏后，点击左上角头像-兑换码-输入兑换码进行兑换</div>

        <div class="code">
          <span class="code1">兑换码：</span>
          <span class="code2" id="code-share">{{ state.successData.code }}</span>
          <span class="code3" id="code-btn"
        data-clipboard-action="copy" data-clipboard-target="#code-share"
        @click="copyWaybillNo('#code-btn')">复制</span>
        </div>
      </div>
    </van-popup>

  </div>
</template>
<script setup>
import "animate.css";
import { ref, onMounted, reactive, nextTick } from "vue";
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { setToken } from "@/utils/auth";
// 领券
import { getNewUserCoupon } from "@/api/yzgame.js";
import { getQueryString } from "../../utils/location";
import { Dialog, Toast } from "vant";
import StatusView from "../public/StatusView.vue";
import { welfareTreasureExchange, welfareTreasureGameInfo, welfareTreasureGameLists } from "../../api/welfare";

import welfareTreasureGamePopup from "../public/welfareTreasureGamePopup.vue"
import router from "../../router";
import Clipboard from "clipboard";
import {
  detect,
} from '@/utils/device';
import { handleCopy } from "../../utils/tool";
const state = reactive({
  images: [],

  loading: false,
  finished: false,
  gameList: [],
  gamename: "",
  
  username: "",
  uid: "",
  type: "android",
  gid: "",

  activeIndex: 0,
  activeGame: {},

  showGame: false,

  show: false,
  successData: {},
});

onMounted(() => {

  try {
    if (detect() == "android" || detect() == "harmony") {
      window.JsBridge.setStatusBar("dark");
    } 
  } catch (error) {
    
  }


  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }

  

  state.uid = getQueryString("uid");
  state.username = getQueryString("username");
  state.gid = getQueryString("gid");

  getTreasureGameLists()
});


var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiperLottery", {
    // autoplay: {
    //   delay: 0,
    //   stopOnLastSlide: false,
    //   disableOnInteraction: false,
    //   waitForTransition: false,
    // },

    speed:1000,//自动滑动开始到结束的时间（单位ms）
    loop:true,//开启循环
    loopedSlides:5,//在loop模式下使用slidesPerview:'auto',还需使用该参数设置所要用到的loop个数。
    slidesPerView: 6.5,//设置slider容器能够同时显示的slides数量(carousel模式)。另外，支持'auto'值，会根据容器container的宽度调整slides数目。
    spaceBetween: 10,
    centeredSlides:true,//设定为true时，active slide会居中，而不是默认状态下的居左。
    slideToClickedSlide: true
    // onSlideChangeEnd: function(swiper){
    //   // console.log(swiper)
    //   // state.activeIndex = swiper.activeIndex
    //   // state.activeGame = state.images[state.activeIndex]

    // }
  });

  mySwiper.on('slideChange', () => {
    console.log('当前索引:', mySwiper.realIndex)
    console.log('当前 Slide:', mySwiper.slides[mySwiper.realIndex])
   
    state.activeIndex = mySwiper.realIndex
    state.activeGame = state.images[state.activeIndex]
 console.log('当前game:', state.activeGame)
    refresh()
  })

};

const getTreasureGameLists = ()=>{
  welfareTreasureGameLists({
    username: state.username,
    type: state.type,
    val: state.gamename,
  }).then(res=>{
    console.log(res)
    if(res.data.code == 1){
      state.images = res.data.data



      nextTick(() => {
        mySwiper && mySwiper.destroy();
        initSwiper();


        if(state.images.length > 0){
          if(state.gid){
            if(state.images[0].id == state.gid){
              state.activeIndex = 0
              state.activeGame = state.images[state.activeIndex]

              refresh()
            }else {
              for (let i = 0; i < state.images.length; i++) {
              if(state.images[i].id == state.gid){
                mySwiper.slideToLoop(i,500,true)
                break
              }
            }
            }
            
          }else{
            state.activeIndex = 0
              state.activeGame = state.images[state.activeIndex]

              refresh()
          }    
        }
        
      });


      
    }
  })
}


//领取新人福利优惠券
const getNewWelfare = async () => {
  // 领取新人福利
  getNewUserCoupon({ uid: state.uid }).then((res) => {
    // console.log("领取新人福利返回的数据-------------", res);
    if (res.data.code == 1) {
      Toast("领取成功");
    } else {
      Toast(res.data.msg);
    }
  });
};

const goExchange = (item)=>{
  if(item.is_exchanged == 0){
    Dialog.confirm({
      title: '温馨提示',
      message:
        `是否兑换${item.prop_name}？`,
    })
      .then(() => {
        // on confirm
        welfareTreasureExchange({
          game_id:item.game_id,
          treasure_id: item.id,
          username:state.username
        }).then(res=>{
          if(res.data.code == 1){
            
            state.show = true
            state.successData = {
              ...item,
              ...res.data.data
            }

            refresh()
          } else {
            Toast(res.data.msg);
          }
        })
      })
      .catch(() => {
        // on cancel
      });
  }

}

const onGameItem = (item)=>{
  for (let i = 0; i < state.images.length; i++) {
    if(state.images[i].id == item.id){
      console.log(i,item,state.images)
      if(mySwiper){
        mySwiper.slideToLoop(i,500,true)
      }
      return
    }
  }

}

const goBack = ()=>{
  if (detect() == "android" || detect() == "harmony") {
    window.document.location = "goBack://";
  } else {
    router.go(-1);
  }
  
}

const goReocrd = ()=>{
  router.push({path: "/newwelfareTreasureRecord",query: {
    uid: state.uid,
    username: state.username
  }})
}

const goSearch = ()=>{
  state.showGame = true
}
// 保证分页变量响应式且适用于多次调用
let pagecode = 0;
let fetchFlag2 = false;

const refresh = () => {
  state.gameList = [];
  pagecode = 0;
  state.finished = false;
  onLoad();
};

const onLoad = async () => {
  pagecode++;
  await getGameList();
};

const getGameList = async () => {
  if (fetchFlag2) return;
  fetchFlag2 = true;


  welfareTreasureGameInfo({
    pagecode: pagecode,
    game_id: state.activeGame.id,
    username: state.username
  }).then(res=>{
    if(res.data.code == 1){
      state.gameList = res.data.data;
    }
    
  }).finally(()=>{
    state.finished = true;
    state.loading = false;
    fetchFlag2 = false;
  })

};



const copyWaybillNo = (id) => {
  // let clipboard = new Clipboard(id);
  // nextTick(() => {
  //   clipboard.on("success", function () {
  //     Toast("礼包码已复制");
  //     clipboard.destroy();
  //   });
  //   clipboard.on("error", function () {
  //     Toast("您的浏览器不支持点击复制");
  //     clipboard.destroy();
  //   });
  // });
  handleCopy(id,state.successData.code)
};

</script>
<style>
body {
  background: #F1F5F0;
}
</style>

<style scoped>

.navbox {
  position: relative;
  height: 90px;
  width: 100%;
}

.navbox .left {
  width: 70px;
  height: 70px;
  padding: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
}


.navbox .title {
  font-size: 30px;
  color: #333;
  font-weight: 600;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.navbox .right {
  font-size: 24px;
  color: #00D9C5;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 32px;
}

.welfare-content {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-image: url("../../assets/welfare/flbk_bg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.gift-box {
  flex: 1;
  background: linear-gradient(180deg, #e8faff, #eaf3f5);
  border: 2px solid #FFFFFF;
  border-radius:  60px 60px 0px 0px;
  margin-top: 20px;
  overflow: scroll;
  padding-top: 40px;
}

:deep(.van-search){
  padding: 2px 32px !important;
}

:deep(.van-search .van-search__content) {
  background-color: white;
  border-radius: 38px;
  border: 2px solid #D9D9D9;
  line-height: 76px;
  color: #333;
}

:deep(.van-search input::placeholder) {
  color: #666;
}

.search {
  height: 76px;
  background-color: white;
  border-radius: 38px;
  border: 2px solid #D9D9D9;
  line-height: 76px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 32px;
  margin-right: 32px;
  font-size: 28px;
  font-weight: 400;
  margin-top: 12px;
}

.game-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
}

.game-info .gamename {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}
.game-info .center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}
.game-info .discount {
  font-size: 24px;
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  font-family: 'bbt';
  color: white;
  background: linear-gradient(90deg, #ff6666, #ffac5f);
  border-radius: 6px;
}

.game-info .tag {
  font-size: 20px;
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  margin-left: 8px;
  color: #666;
}

.game-info .gift {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}
.game-info .gift span {
  color: #ff6666;
}

.swiperLottery {
  /* width: 500px; */
  height: 160px;
  touch-action: pan-y pinch-zoom;
}
.swiperLottery .swiper-wrapper {

}
.swiperLottery div div {
  width: 130px ;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiperLottery div img {
  object-fit: contain;
}
.swiper-slide-active {
  color: #fff;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.77);
}
.swiper-slide img {
  width: 100%;
  /* height: 100%; */
  border-radius: 30px;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1.23);
}

.swiper-slide-active img,
.swiper-slide-duplicate-active img {
  border-radius: 30px;
  border: 4px solid #9CEAFF;
}



:deep(.van-grid .van-grid-item__content) {
  background-color: #fff;
  border-radius: 30px;
  height: 272px;
  position: relative;
  padding: 0px;
}

.coupon-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  overflow: 
  hidden;
}

.coupon-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-top: 4px;
  border-radius: 12px;
}

.coupon-limit {
  color: white;
  font-size: 20px;
  position: absolute;
  border-radius:  30px 0px 30px 0px;
  background: #00ceff;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 2px;
  padding-bottom: 2px;
  top: 0;
  left: 0;

}

.coupon-name {
  font-size: 20px;
  color: #333;
  margin-top: 8px;
  max-width: 150px;
}

.coupon-num {
  flex: 1; 
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: #FFC01F;
  font-size: 28px;
  font-weight: bold;
}

.coupon-num img{
  width: 28px;
  height: 28px;
  margin-right: 4px;
}


.coupon-btn {
  align-self: stretch;
  flex-basis: 1;
  height: 48px;
  color: white;
  font-size: 24px;
  background: #00CEFF;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.coupon-btn2 {
  align-self: stretch;
  flex-basis: 1;
  height: 48px;
  color: white;
  font-size: 24px;
  background: #C6CAD3;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}



:deep(.van-popup) {
  border-radius: 24px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 620px;
  border-radius: 24px;
  background-color: white;
}
.popup-box .titlebox {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  font-size: 44px;
  margin-top: 24px;
}
.popup-box .imgbox {
  width: 200px;
  height: 200px;
  border-radius: 24px;
  background-color: #F0FFFE;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}
.popup-box .imgbox img {
  width: 120px;
  height: 120px;
}
.popup-box .name {
  font-size: 28px;
  color: #333333;
  margin-top: 12px;
}
.popup-box .tip {
  font-size: 24px;
  color: #999999;
  margin-top: 12px;
  text-align: center;
  margin-left: 66px;
  margin-right: 66px;
}
.popup-box .code {
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  margin-top: 24px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
}
.popup-box .code3 {
  font-size: 24px;
  color: #00D9C5;
  margin-left: 12px;
}
.closeimg {
  width: 48px;
  height: 48px;
  position: absolute;
  right: 32px;
  top: 8px;
}
</style>
